export default __webpack_public_path__ + "static/index-flip-606da4b08c9585b1eeea97bb9cd017e2.png";